import { rgba } from 'polished'
import * as colors from './colors'
import { responsiveStyles } from './util'

import './fonts'

// Place global Typography in this file
export const primaryFont = "'Freight Sans', -apple-system, sans-serif"
export const secondaryFont = "'Copernicus', -apple-system, serif"
export const normal = 'normal'
export const medium = 500
export const bold = 700


export const bodyExtraLarge = `
	${ responsiveStyles('font-size', 22, 18, 17, 16) }
	line-height: 1.8em;
	font-family: ${ secondaryFont };
	letter-spacing: 0;
	text-transform: none;
	font-weight: normal;
`
export const bodyLarge = `
	${ responsiveStyles('font-size', 22, 20, 18, 17) }
	line-height: 1.5em;
	font-family: ${ primaryFont };
	letter-spacing: 0.02em;
	text-transform: none;
	font-weight: normal;
`
export const body = `
	${ responsiveStyles('font-size', 20, 18, 17, 16) }
	line-height: 1.75em;
	font-family: ${ primaryFont };
	letter-spacing: 0.02em;
	text-transform: none;
	font-weight: normal;
`
export const bodySmall = `
	${ responsiveStyles('font-size', 17, 16, 15, 14) }
	line-height: 1.75em;
	font-family: ${ primaryFont };
	letter-spacing: 0;
	text-transform: none;
	font-weight: normal;
`

export const h1 = `
	${ responsiveStyles('font-size', 70, 50, 40, 30) }
	line-height: 1.4em;
	font-family: ${ secondaryFont };
	font-weight: normal;
	letter-spacing: -.02em;
	text-transform: none;
`

export const h2 = `
	${ responsiveStyles('font-size', 58, 44, 36, 26) }
	line-height: 1.4em;
	font-family: ${ secondaryFont };
	font-weight: normal;
	letter-spacing: -.02em;
	text-transform: none;
`

export const h3 = `
	${ responsiveStyles('font-size', 52, 36, 30, 24) }
	line-height: 1.5em;
	font-family: ${ secondaryFont };
	font-weight: normal;
	letter-spacing: -.02em;
	text-transform: none;
`

export const h4 = `
	${ responsiveStyles('font-size', 36, 30, 28, 22) }
	line-height: 1.575em;
	font-family: ${ secondaryFont };
	font-weight: normal;
	letter-spacing: -.02em;
	text-transform: none;
`

export const h5 = `
	${ responsiveStyles('font-size', 30, 24, 20, 18) }
	font-family: ${ primaryFont };
	font-weight: ${ medium };
	line-height: 1.25em;
	letter-spacing: 0;
	text-transform: none;
`
export const h6 = `
	${ responsiveStyles('font-size', 16, 14, 14, 13) }
	font-family: ${ primaryFont };
	font-weight: ${ bold };
	line-height: 1.285em;
	letter-spacing: .1em;
	text-transform: uppercase;
`

export const blockquote = `
	${ bodyLarge }
	font-style: normal;
`

export const eyebrow = `
	${ h6 }
`

export const smallCaps = `
	${ h6 }
	${ responsiveStyles('font-size', 14, 13, 12, 12) }
`

export const buttonStyle = `
	${ h6 }
	${ responsiveStyles('font-size', 14, 14, 14, 13) }
	line-height: 1em;
`

export const storyNotes = `
	max-width: 750px;
	p {
		code {
			background: ${ rgba(colors.textColor, 0.1) };
			color: ${ colors.textColor };
			border-radius: 3px;
			padding: .05em .35em .15em;
			font-style: normal;
		}
	}
`
